import { useCallback, useEffect, useState } from 'react';
import { Organization } from '../../widgets/organization/organization';
import './organizations.css';
import { Button } from '../../widgets/button/button';
import { ReactComponent as CompareIcon } from '../../../assets/compare.svg';
import { ReactComponent as SortIcon } from '../../../assets/sort.svg';
import { useFilter } from '../../../contexts/filter-context';
import { Loading } from '../../widgets/loading/loading';
import { useModal } from '../../../contexts/modal-context';
import { useOrganizations } from '../../../contexts/organization-context';
import * as qs from 'qs';
import { useNavigation } from '../../../contexts/navigation-context';
import InfiniteScroll from 'react-infinite-scroll-component';
import * as cn from 'classnames';

export const OrganizationsPage = ({ activities }) => {
  const [organizationData, setOrganizationData] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const filters = useFilter();
  const { organizationIds } = useOrganizations();
  const { setOpen } = useModal();
  const { to } = useNavigation();
  const [isScrolled, setIsScrolled] = useState(false);
  const scrollContainerRef = useCallback((node) => {
    if (node !== null) {
      const onScroll = () => {
        setIsScrolled(node.scrollTop > 0);
      };
      node.addEventListener('scroll', onScroll, { passive: true });
      // return () => node.removeEventListener('scroll', onScroll);
    }
  }, []);

  const loadOrganizations = async (replaceResults) => {
    setIsLoading(replaceResults ? true : false);
    const queryObj = {
      phaseIds: filters.phaseIds,
      causeIds: filters.causeIds,
      activityIds: filters.activityIds,
      sort: filters.sortSpec.map((ss) => ({ f: ss.id, d: ss.direction })),
      stars: filters.stars,
      count: 20,
      start: replaceResults ? 0 : organizations.length,
      search: filters.search,
    };
    const result = await fetch(process.env.REACT_APP_API_URL + '/organizations?' + qs.stringify(queryObj));
    const { results, ...resultData } = await result.json();
    setOrganizations([...(replaceResults ? [] : organizations), ...results]);
    setOrganizationData(resultData);
    setIsLoading(false);
  };

  useEffect(() => {
    loadOrganizations(true);
  }, [filters]);

  const handleCompareClicked = () => {
    to({ pageId: 'organizations-compare', params: { organizationIds } });
  };

  return (
    <>
      <div className="organizations-page">
        <div className={cn('page-header', isScrolled ? 'scrolled' : '')}>
          <div className="page-title"></div>
          <div className="page-header-button-container">
            <Button icon={<CompareIcon />} onClick={handleCompareClicked} disabled={organizationIds.length === 0 || organizationIds.length > 4}>
              Compare
            </Button>
            <Button icon={<SortIcon />} onClick={() => setOpen('sort-modal', true)}>
              Sort Options
            </Button>
          </div>
        </div>
        {isLoading && (
          <div className="organizations-loading-container">
            <Loading />
          </div>
        )}
        {!isLoading && (
          <div className="organizations-scroll-container" id="scroll-container" ref={scrollContainerRef}>
            {organizations.length === 0 && <div className="organizations-empty-message">No organizations found that meet the currently selected filters</div>}
            <InfiniteScroll
              className="organizations-container-scroll"
              dataLength={organizations.length} //This is important field to render the next data
              next={() => loadOrganizations(false)}
              hasMore={organizationData?.hasNextPage || false}
              loader={<Loading />}
              scrollableTarget="scroll-container"
            >
              <div className="organizations-container">
                {organizations.map((o) => (
                  <Organization key={o.EIN} organization={o} activities={activities}></Organization>
                ))}
              </div>
            </InfiniteScroll>
          </div>
        )}
      </div>
    </>
  );
};
